import { getToken } from './user-service';

const BASE_URL = "/api/v1/cpu/sla-reports/kpis";

class KPIService {
  async getExternalKPIs(params = {}, signal) {
    const token = await getToken();
    const { date, startDate, endDate, iata } = params;
    const query = new URLSearchParams({ iata });

    if (date) query.append("date", date);
    if (startDate) query.append("startDate", startDate);
    if (endDate) query.append("endDate", endDate);

    const url = `${BASE_URL}?${query.toString()}`;

    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Firebase-UID": token,
          },
          signal,
        });

        if (response.status >= 400 && response.status < 600) {
          const errorText = await response.text();
          throw new Error(`Failed to load SLA KPIs: ${response.status} ${errorText}`);
        }

        const json = await response.json();
        resolve(json);
      } catch (error) {
        if (error.name === "AbortError") {
          reject(new Error("Request aborted"));
          return;
        }
        reject(error);
      }
    });
  }
}

export default new KPIService();

